export { default } from "@src/Apps/Updates";
